export default {"src":"/_next/static/media/Social_youtube.09425bec.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};